import { PropsWithChildren, ReactNode, useEffect, useState } from "react";
import Button from "./Button/Button";
import Input from "./Forms/Input";
import CanonicalModal from "./CanonicalModal/CanonicalModal";

type ConfirmationModalProps = PropsWithChildren<{
    open?: boolean,
    onCancel: () => void,
    onConfirm: () => void,
    title: string,
    subtitle?: ReactNode,
    // when set, Confirm stays disabled until the user types this exact phrase - for higher-severity deletions
    requireTypedConfirmation?: string,
}>

function ConfirmationModal({open = false, onCancel, onConfirm, title, subtitle, requireTypedConfirmation, children}: ConfirmationModalProps) {
    const [typedConfirmation, setTypedConfirmation] = useState('');

    // reset so a stale value can't silently satisfy the check next time the modal opens
    useEffect(() => {
        if (!open) {
            setTypedConfirmation('');
        }
    }, [open]);

    const confirmDisabled = !!requireTypedConfirmation && typedConfirmation !== requireTypedConfirmation;

    return (
        <CanonicalModal
            open={open}
            onClose={onCancel}
            size="small"
            title={title}
            subtitle={subtitle}
            actions={
                <>
                    <Button type="Primary" text="Confirm" onClick={onConfirm} disabled={confirmDisabled} additionalClass="mr-5" />
                    <Button type="Outlined" text="Cancel" onClick={onCancel} />
                </>
            }
        >
            { children }
            { requireTypedConfirmation && (
                <Input
                    type="text"
                    name="typedConfirmation"
                    label={<>To confirm type <em>{requireTypedConfirmation}</em> in the field</>}
                    placeholder={requireTypedConfirmation}
                    additionalClass="mt-8"
                    value={typedConfirmation}
                    onChange={e => setTypedConfirmation(e.target.value)}
                />
            )}
        </CanonicalModal>
    )
}

export default ConfirmationModal;
